module.exports = __webpack_public_path__ + "static/media/Smaragdenia_Filaki_5.2b4be63d.jpeg";